/* ==================================================
 *  Smooth Scrolling
 *  ==================================================*/

(function() {

  'use strict';

  $('[data-scroll]').click(function() {
    var target = $(this).attr('data-scroll');
    target = $(target);
    if (target.length) {
      var offset = target.offset().top;
      $('html,body').animate({
        scrollTop: offset
      }, 1000);
      return false;
    }
  });
})();
